// extracted by mini-css-extract-plugin
export var basic = "ConversionBlock-module--basic--b231d";
export var btnCaption = "ConversionBlock-module--btnCaption--6d999";
export var diagonalFrosting = "ConversionBlock-module--diagonalFrosting--0ad53";
export var heading = "ConversionBlock-module--heading--f8328";
export var image = "ConversionBlock-module--image--32e53";
export var mediaColumn = "ConversionBlock-module--mediaColumn--ae0b8";
export var messaging = "ConversionBlock-module--messaging--e5f9c";
export var movingGradient = "ConversionBlock-module--movingGradient--8e49f";
export var split = "ConversionBlock-module--split--debc4";
export var textContent = "ConversionBlock-module--textContent--39201";
export var wrapper = "ConversionBlock-module--wrapper--91d1f";